/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* A place for VDK Web CTV UI components and utilities (@accedo/vdkweb-tv-ui) 7.1.2
* 
*******************************************************************************/
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import { RadioButtonOffIcon, RadioButtonOnIcon, DeleteIcon, UppercaseIcon } from './keyboardIcons';
import styles from '../keyboard.scss';
var backspace = /*#__PURE__*/React.createElement(DeleteIcon, {
  className: styles.icon
});
var uppercase = /*#__PURE__*/React.createElement(UppercaseIcon, {
  className: styles.icon
});
var space = /*#__PURE__*/React.createElement("div", {
  style: {
    transform: 'rotate(-90deg)'
  }
}, "[");
var layout1 = /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(RadioButtonOffIcon, {
  className: styles.icon
}), ' AB12');
var layout1Active = /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(RadioButtonOnIcon, {
  className: styles.icon
}), ' AB12');
var layout2 = /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(RadioButtonOffIcon, {
  className: styles.icon
}), ' !?#$');
var layout2Active = /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(RadioButtonOnIcon, {
  className: styles.icon
}), ' !?#$');
export var KEYBOARD_SPECIALKEYS_MAP = {
  uppercase: 'uppercase',
  backspace: 'delete',
  layoutSymbols: 'layout2',
  layoutLetters: 'layout1',
  space: 'space',
  clear: 'clear',
  search: 'search',
  dotnet: '.net',
  dotcom: '.com'
};
export var uppercaseSingleButton = {
  text: KEYBOARD_SPECIALKEYS_MAP.uppercase,
  value: ' ',
  component: uppercase,
  columns: 1,
  func: function func(text, switchUppercase) {
    switchUppercase();
  }
};
export var backspaceSingleButton = {
  text: KEYBOARD_SPECIALKEYS_MAP.backspace,
  value: '\b',
  component: backspace,
  columns: 1,
  func: null
};
export var backspaceDoubleButton = {
  text: KEYBOARD_SPECIALKEYS_MAP.backspace,
  value: '\b',
  component: backspace,
  columns: 2,
  themeClass: 'buttonDoubleSizeContainer',
  func: null
};
export var layoutSymbolsButton = {
  text: KEYBOARD_SPECIALKEYS_MAP.layoutSymbols,
  value: ' ',
  component: layout2,
  columns: 2,
  themeClass: 'buttonDoubleSizeContainer',
  func: null
};
export var layoutSymbolsActiveButton = _objectSpread(_objectSpread({}, layoutSymbolsButton), {}, {
  component: layout2Active
});
export var layoutLettersButton = {
  text: KEYBOARD_SPECIALKEYS_MAP.layoutLetters,
  value: ' ',
  component: layout1,
  columns: 2,
  themeClass: 'buttonDoubleSizeContainer',
  func: null
};
export var layoutLettersActiveButton = _objectSpread(_objectSpread({}, layoutLettersButton), {}, {
  component: layout1Active
});
export var spaceFourspaceButton = {
  text: KEYBOARD_SPECIALKEYS_MAP.space,
  value: ' ',
  component: space,
  columns: 4,
  themeClass: 'buttonQuadrupleSizeContainer',
  func: null
};
export var spaceDoublespaceButton = {
  text: KEYBOARD_SPECIALKEYS_MAP.space,
  value: ' ',
  component: space,
  columns: 2,
  themeClass: 'buttonDoubleSizeContainer',
  func: null
};
export var spaceTriplespaceButton = {
  text: KEYBOARD_SPECIALKEYS_MAP.space,
  value: ' ',
  component: space,
  columns: 3,
  themeClass: 'buttonTripleSizeContainer',
  func: null
};
export var clearDoublespaceButton = {
  text: KEYBOARD_SPECIALKEYS_MAP.clear,
  value: 'c',
  themeClass: 'buttonDoubleSizeContainer',
  columns: 2,
  func: null
};
export var searchSixspacesButton = {
  text: KEYBOARD_SPECIALKEYS_MAP.search,
  value: 'search',
  themeClass: 'buttonSextupleSizeContainer',
  columns: 6,
  func: null
};
export var dotnetButton = {
  text: KEYBOARD_SPECIALKEYS_MAP.dotnet,
  value: '.net',
  columns: 2,
  themeClass: 'buttonDoubleSizeContainer',
  func: null
};
export var dotcomButton = {
  text: KEYBOARD_SPECIALKEYS_MAP.dotcom,
  value: '.com',
  columns: 2,
  themeClass: 'buttonDoubleSizeContainer',
  func: null
};